module.exports = __webpack_public_path__ + "img/17.7fc84a61.jpg";